import { useController } from 'react-hook-form';
import type { OnChangeFn, SortingState, Updater } from '@tanstack/react-table';
import { mapOrderingToSortingState, mapSortingStateToOrdering } from './mapSortingStateToOrdering';
import { useCallback, useMemo } from 'react';

export const useOrderingState = (): [SortingState, OnChangeFn<SortingState>] => {
  const { field } = useController({ name: 'ordering' });

  const value = useMemo(() => mapOrderingToSortingState(field.value), [field.value]);

  const onSortingChange: OnChangeFn<SortingState> = useCallback(
    (updaterOrValue: Updater<SortingState>) => {
      const nextState = typeof updaterOrValue === 'function' ? updaterOrValue(value) : updaterOrValue;

      const ordering = mapSortingStateToOrdering(nextState);
      field.onChange(ordering);
    },
    [field, value],
  );

  return [value, onSortingChange];
};
